<template>
  <div class="login-background">
    <img
      src="@/assets/ScannerBackground.png"
      alt="Background"
      class="background-image"
    >
    <div class="login-container">
      <img
        src="@/assets/StaffTrainingLogo.png"
        alt="Staff Training Logo"
        class="company-logo"
      >
      <h2>Welcome to Staff Training Inventory Management System</h2>
      <form @submit.prevent="loginUser">
        <label for="email">Email:</label>
        <input
          id="email"
          v-model="email"
          type="email"
          autocomplete="email"
          required
        >

        <label for="password">Password:</label>
        <input
          id="password"
          v-model="password"
          type="password"
          autocomplete="current-password"
          required
        >

        <button type="submit">
          Login
        </button>
      </form>
      <p v-if="errorMessage">
        {{ errorMessage }}
      </p>
      <!-- Add to Home Screen Button -->
      <button
        v-if="isInstallPromptAvailable"
        class="install-button"
        @click="installApp"
      >
        Add to Home Screen
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters(['isInstallPromptAvailable']), // Getter for install prompt availability
  },
  methods: {
    ...mapActions(['setInstallPromptAvailable']), // Action to manage install prompt availability

    async loginUser() {
      try {
        // Update the Axios request to include credentials
        const response = await axios.post(
          'https://api.inventory.stafftraining.me/api/login',
          {
            email: this.email,
            password: this.password,
          },
          {
            withCredentials: true, // Include credentials with the request
          },
        );

        if (response.data && response.data.token && response.data.role) {
          // Store the JWT token for future requests
          localStorage.setItem('authToken', response.data.token);
          this.$store.dispatch('setUserRole', response.data.role);

          // Check the user's role and navigate accordingly
          if (response.data.role === 'admin') {
            this.$router.push('/admin'); // Redirect to Admin Dashboard if the role is admin
          } else if (response.data.role === 'trainer') {
            this.$router.push('/scanner'); // Redirect to Scanner if the role is trainer
          }
        } else {
          this.errorMessage = 'Invalid login credentials.';
        }
      } catch (error) {
        console.error('Login error:', error);
        this.errorMessage = 'Login failed. Please try again.';
      }
    },

    installApp() {
      this.$showAddToHomeScreen(); // Use globally available function from main.js
      this.setInstallPromptAvailable(false); // Reset availability after prompt
    },
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
  margin: 0;
}

/* Full-screen background image */
.login-background {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.3;
  z-index: 1;
}

/* Style for the login container */
.login-container {
  position: relative;
  width: 300px;
  margin: 80px auto 0 auto; /* Center vertically with margin from top */
  text-align: center;
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9); /* Lighten up and add transparency */
  z-index: 2; /* Ensure that the login container appears above the background */
}

/* Company logo style */
.company-logo {
  width: 100px;
  height: auto; /* Maintain aspect ratio */
  display: block;
  margin: 0 auto 20px auto; /* Center the logo and add spacing below */
}

/* Style for welcome message */
h2 {
  font-size: 20pt;
  margin-bottom: 20px;
  color: var(--primary-color);
}

/* Form styling */
form {
  display: flex;
  flex-direction: column;
}

label,
input,
button {
  margin-bottom: 10px;
}

/* Button styling */
button {
  background-color: var(--primary-color);
  color: var(--text-light-color);
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}

button:hover {
  background-color: var(--primary-hover-color);
}

/* Add to Home Screen button styling */
.install-button {
  margin-top: 15px;
  background-color: var(--secondary-color);
  color: var(--text-light-color);
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}

.install-button:hover {
  background-color: var(--secondary-hover-color);
}
</style>
